/**
 * @module uid
 * @since 2.1.0
 */

import { glob } from '../../environment';

/**
 * Generate a pseudorandom id
 *
 * @return {String}  pseudorandom id derived from timestamp
 *
 * @example uid();
 * // 9807528710537
 */
const generateUid = () => `${Math.random()}`.slice(-8) + `${Date.now()}`.slice(8);

const UID = Symbol.for('futile uid');
glob[UID] = glob[UID] || new Set();

/**
 * Generate a unique pseudorandom id and stores it on a global uid storage for guaranteed uniqueness.
 *
 * @return {String}
 *
 * @example
 * uid(); // '9807528710537'
 * uid(); // '8309873347381'
 */
export function uid() {
    let generatedUid = generateUid();

    while (glob[UID].has(generatedUid)) {
        generatedUid = generateUid();
    }

    glob[UID].add(generatedUid);
    return generatedUid;
}
